import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import RegistrationFormService from '../services/RegistrationFormService';
import ValidateableTextInputField from "./ValidateableTextInputField";

class EmailField extends Component {

  validateValue = (value) => {
    if (this.props.isRequired) {
      return RegistrationFormService.validateEmail(value);
    } else {
      return RegistrationFormService.validateNonRequiredEmail(value);
    }
  };

   render() {
      return (
          <React.Fragment>
            <ValidateableTextInputField
                validationFunction={this.validateValue}
                onChange={this.props.onChange}
                fieldLabel={this.props.fieldLabel}
                showErrors={this.props.showErrors}
                customError={this.props.errorMessage}
            />
          </React.Fragment>
      )
   }
}

EmailField.propTypes = {
  fieldLabel: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  isRequired: PropTypes.bool,
  showErrors: PropTypes.bool,
  errorMessage: PropTypes.string
};

export default EmailField;

